import { z } from 'zod';
import { uuidSchema } from './common.schema';

// ─── Enums ────────────────────────────────────────────────────────────────────

export const MilkProviderTypeLabelEnum = z.enum(['mother', 'donor', 'both']);
export type MilkProviderTypeLabel = z.infer<typeof MilkProviderTypeLabelEnum>;

// ─── Request ──────────────────────────────────────────────────────────────────

export const CreateMilkBottleLabelsRequestSchema = z.object({
  provider_id:        uuidSchema,
  milk_provider_type: MilkProviderTypeLabelEnum,
  no_of_bottles:      z.number().int().min(1).max(500),
  tenant_id:          uuidSchema,
});

export type CreateMilkBottleLabelsRequest = z.infer<typeof CreateMilkBottleLabelsRequestSchema>;

// ─── Response ─────────────────────────────────────────────────────────────────

export const MilkBottleLabelItemSchema = z.object({
  label_id:            uuidSchema,
  tenant_id:           uuidSchema,
  milk_provider_id:    uuidSchema,
  milk_provider_type:  MilkProviderTypeLabelEnum,
  custom_label:        z.string(),
  created_by:          uuidSchema,
  created_at:          z.string(),
});

export type MilkBottleLabelItem = z.infer<typeof MilkBottleLabelItemSchema>;

export const CreateMilkBottleLabelsResponseSchema = z.object({
  labels: z.array(MilkBottleLabelItemSchema),
  count:  z.number().int(),
});

export type CreateMilkBottleLabelsResponse = z.infer<typeof CreateMilkBottleLabelsResponseSchema>;
